import React from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getPricePlanById } from '../../api/pricePlans';
import { Card, Typography, Button, Space, message } from 'antd';
import type { PricePlan } from '../../types/pricePlans';

const { Title, Text } = Typography;

const PricePlanDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const statePlan = location.state?.pricePlan as PricePlan | undefined;

  const { data: pricePlan, isLoading } = useQuery<PricePlan | null>({
    queryKey: ['pricePlan', id],
    queryFn: () => getPricePlanById(id!),
    enabled: !statePlan && !!id,
    initialData: statePlan,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading || !pricePlan) return <Card loading />;

  return (
    <Card>
      <Title level={3}>{pricePlan.name}</Title>
      <Text>{pricePlan.description}</Text>
      <div style={{ margin: '16px 0' }}>
        <Space>
          <Button type="primary" onClick={() => message.info('Edit not implemented')}>Edit</Button>
          <Button danger onClick={() => message.info('Delete not implemented')}>Delete</Button>
          <Button onClick={() => navigate(-1)}>Back</Button>
        </Space>
      </div>
      <div>
        <Text strong>Max Units:</Text> {pricePlan.max_units}<br />
        <Text strong>Max Employees:</Text> {pricePlan.max_employees}<br />
        <Text strong>Max Users:</Text> {pricePlan.max_users}<br />
        <Text strong>Features:</Text> {pricePlan.features?.join(', ')}<br />
        <Text strong>Type:</Text> {pricePlan.is_custom ? 'Custom' : 'Standard'}<br />
      </div>
    </Card>
  );
};

export default PricePlanDetailsPage; 